import axios from "axios";
import Cookies from "js-cookie";

const axiosInstance = axios.create({
  baseURL: "https://booznovenueqa.api.dweb.in/api", // Your API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptors
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify request config, add tokens, etc.
    const token = Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return error;
  }
);

// Add response interceptors if needed
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (response) => {
    if (response?.response?.status === 401) {
      window.location.pathname = "/";
      Cookies.remove("token");
    }
    return response.response?.data || response;
  }
);

export default axiosInstance;
